<template>
  <div id="app9">
      <Carousel :slides="slides"></Carousel>
  </div>
</template>

<script>
import Carousel from './components/Carousel';

export default {
  name: 'AppS',
   data: () => ({
    slides: [
     "/wp-content/uploads/2024/10/welding-1.webp",
     "/wp-content/uploads/2024/10/HERO2-1.webp",
    ]
  }),
  components: {
    Carousel,
  }
}
</script>
